import {Dropdown} from '@fluentui/react';

import React from "react";

class ResultsOnPage extends React.Component
{
    selectionChange = (e,v) =>
    {
        this.props.onPageResults(v.key);
    }

    render() {
        const values = [20, 50, 100, 200];
        return(
            <div style={{position: 'absolute', right: '120px', top: 0}}>
                <Dropdown
                    label="Results on page:"
                    onChange= {this.selectionChange}
                    placeholder="Items on page"
                    options={values.map(x => ({key: x, text: x}))}
                    selectedKey= {this.props.onPage}
                    styles={{dropdown: { width: 70, display: 'inline-block', verticalAlign: 'middle', marginLeft: '10px'} }}
                />
            </div>
        );
    }
}
export default ResultsOnPage















// WEBPACK FOOTER //
// ./src/components/Administration/ResultsOnPage.js